module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "denta_promotion"
  }, [_c('div', [_c('div', {
    staticClass: "firstQuestion answer_shell center"
  }, [_c('answer', {
    attrs: {
      "answer-title": "Приветсвтие",
      "answer-audio": _vm.scenario.parameters.mainQuestionAudio,
      "answer-text": _vm.scenario.parameters.mainQuestionText,
      "is-saved": _vm.isSaved,
      "client": _vm.scenario.client
    },
    on: {
      "update:answerAudio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionAudio", $event)
      },
      "update:answer-audio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionAudio", $event)
      },
      "update:answerText": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionText", $event)
      },
      "update:answer-text": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionText", $event)
      },
      "generateAudioHandler": _vm.setMainQuestionAudio,
      "deleteAudioHandler": _vm.deleteMainQuestionAudio,
      "setAudioDuration": _vm.setMainQuestionAudioDuration
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "answers"
  }, [_c('div', {
    staticClass: "afterYes answer_shell"
  }, [_c('answer', {
    attrs: {
      "answer-title": "Да",
      "answer-audio": _vm.scenario.parameters.onYesAudio,
      "answer-text": _vm.scenario.parameters.onYesText,
      "is-saved": _vm.isSaved,
      "client": _vm.scenario.client
    },
    on: {
      "update:answerAudio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesAudio", $event)
      },
      "update:answer-audio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesAudio", $event)
      },
      "update:answerText": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesText", $event)
      },
      "update:answer-text": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesText", $event)
      },
      "generateAudioHandler": _vm.setYesAudio,
      "deleteAudioHandler": _vm.deleteYesAudio
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "afterNo answer_shell"
  }, [_c('answer', {
    attrs: {
      "answer-title": "Нет",
      "answer-audio": _vm.scenario.parameters.onNoAudio,
      "answer-text": _vm.scenario.parameters.onNoText,
      "is-saved": _vm.isSaved,
      "client": _vm.scenario.client
    },
    on: {
      "update:answerAudio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoAudio", $event)
      },
      "update:answer-audio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoAudio", $event)
      },
      "update:answerText": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoText", $event)
      },
      "update:answer-text": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoText", $event)
      },
      "generateAudioHandler": _vm.setNoAudio,
      "deleteAudioHandler": _vm.deleteNoAudio
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "afterFail answer_shell"
  }, [_c('answer', {
    attrs: {
      "answer-title": "Молчание/неразборчиво",
      "answer-audio": _vm.scenario.parameters.onFailAudio,
      "answer-text": _vm.scenario.parameters.onFailText,
      "is-saved": _vm.isSaved,
      "client": _vm.scenario.client
    },
    on: {
      "update:answerAudio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onFailAudio", $event)
      },
      "update:answer-audio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onFailAudio", $event)
      },
      "update:answerText": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onFailText", $event)
      },
      "update:answer-text": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onFailText", $event)
      },
      "generateAudioHandler": _vm.setFailAudio,
      "deleteAudioHandler": _vm.deleteFailAudio,
      "setAudioDuration": _vm.setRepeatAudioDuration
    }
  }), _vm._v(" "), _c('answer', {
    attrs: {
      "answer-title": "Второй раз молчание/неразборчиво",
      "answer-audio": _vm.scenario.parameters.onSecondFailAudio,
      "answer-text": _vm.scenario.parameters.onSecondFailText,
      "is-saved": _vm.isSaved,
      "client": _vm.scenario.client
    },
    on: {
      "update:answerAudio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onSecondFailAudio", $event)
      },
      "update:answer-audio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onSecondFailAudio", $event)
      },
      "update:answerText": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onSecondFailText", $event)
      },
      "update:answer-text": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onSecondFailText", $event)
      },
      "generateAudioHandler": _vm.setSecondFailAudio,
      "deleteAudioHandler": _vm.deleteSecondFailAudio
    }
  })], 1)])]), _vm._v(" "), _c('div', [_c('scenario-bar', {
    attrs: {
      "name": _vm.name,
      "is-saved": _vm.isSaved,
      "is-ready": _vm.scenario.isReady,
      "scenario": _vm.scenario
    },
    on: {
      "set": _vm.setScenario
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea0433e2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/depricated/ScenarioDentaPromotion.vue
// module id = 536
// module chunks = 42